module.exports = __webpack_public_path__ + "static/media/ic_24px_tablefile_edit.3bc6e8a6.svg";